import type { IntakeQuestion, QuestionMapping } from '../services/questionMappingService';

export function buildMappingConditionalDisplay(source: IntakeQuestion, questions: IntakeQuestion[], mappings: QuestionMapping[]): string | null {
    if (!source.parentQuestionGuid) return null;

    const parent = questions.find(question => question.questionGuid.toLowerCase() === source.parentQuestionGuid?.toLowerCase());
    const mapping = mappings.find(item => item.intakeQuestionGuid.toLowerCase() === source.parentQuestionGuid?.toLowerCase());
    if (!parent || !mapping) throw new Error('Map the parent question first.');

    const response = source.parentQuesResponse;
    if (!response?.trim()) throw new Error('The child question is missing its parent response condition.');
    if (/\[[0-9a-f-]{36}\]/i.test(response)) throw new Error('The parent response cannot contain a question GUID placeholder.');

    const parentGuid = mapping.scoringQuestionGuid.toLowerCase();
    const isCheckbox = (mapping.targetQuestion?.dataFieldType ?? parent.dataType ?? parent.inputType)?.trim().toLowerCase();
    if (isCheckbox === 'checkbox' || isCheckbox === 'chk') {
        const options = parent.options?.filter(option => option.value?.trim().toLowerCase() === response.trim().toLowerCase()) ?? [];
        const sequence = options[0]?.sequenceNumber;
        if (options.length !== 1 || !Number.isSafeInteger(sequence) || !sequence || sequence <= 0) {
            throw new Error('The parent response must match one checkbox option with a valid sequence.');
        }
        return JSON.stringify({ canHide: `lower('[${parentGuid}]') = 'n'`, sequenceNew: String(sequence) });
    }

    if (response.length > 4096 || /[\\\x00-\x1f]/.test(response)) {
        throw new Error('The parent response contains unsupported conditional-expression characters.');
    }
    return JSON.stringify({ canHide: `lower('[${parentGuid}]') != lower('${response.replace(/'/g, "''")}')` });
}